import * as i0 from "@angular/core";
import * as i1 from "../app/sectionHero/section-hero.component";
export class CompatSectionHeroComponent {
    constructor() {
        this.isActive = false;
    }
    ngOnInit() { }
}
CompatSectionHeroComponent.ɵfac = function CompatSectionHeroComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSectionHeroComponent)(); };
CompatSectionHeroComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CompatSectionHeroComponent, selectors: [["webapp-compat-section-hero"]], hostVars: 2, hostBindings: function CompatSectionHeroComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("WebappCompatWrapper", ctx.isActive);
    } }, decls: 1, vars: 0, template: function CompatSectionHeroComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "app-section-hero");
    } }, dependencies: [i1.SectionHeroComponent], encapsulation: 2, changeDetection: 0 });
